import { render, staticRenderFns } from "./HealthcareExpensesAdd.vue?vue&type=template&id=4bab90eb&scoped=true"
import script from "./HealthcareExpensesAdd.vue?vue&type=script&lang=ts"
export * from "./HealthcareExpensesAdd.vue?vue&type=script&lang=ts"
import style0 from "./HealthcareExpensesAdd.vue?vue&type=style&index=0&id=4bab90eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bab90eb",
  null
  
)

export default component.exports